import * as actions from './actions'
import mutations from './mutations'

const state = {
  loading: false,
  purchaseOrder: [],
  pagination: {
    page: 1,
    limit: 20,
    totalRows: 0,
  },
  productListPurhcase: [],
  courier: [],
  paymentMethod: [],
  lastBillingAddress: null,
  allBillingAddress: [],
  cityListBilling: [],
  areaListBilling: [],
  lastShippingAddress: null,
  allShippingAddress: [],
  cityListShipping: [],
  areaListShipping: [],
  createSuccess: {},
  sumTotalPurchase: null,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
